import UserLogin2Fa from './UserLogin2Fa';

export default UserLogin2Fa;